import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import { StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from './style';

const MyIdmAccordion = ({ title, children, open, defaultExpanded }) => {
    const [show, setShow] = React.useState(false);
    React.useEffect(() => {
        setShow(open);
    }, [open]);
    return (
        <StyledAccordion sx={{ width: '100%' }} data-testid="myidm-accordion" elevation={1} expanded={defaultExpanded || show} onChange={() => setShow(!show)}>
            <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</StyledAccordionSummary>
            <StyledAccordionDetails>{children && <>{children}</>}</StyledAccordionDetails>
        </StyledAccordion>
    );
};

MyIdmAccordion.propTypes = {
    title: PropTypes.any,
    children: PropTypes.any,
    open: PropTypes.any,
    defaultExpanded: PropTypes.bool,
};

MyIdmAccordion.defaultProps = {
    title: 'Title Here',
    children: undefined,
    open: false,
    defaultExpanded: false,
};

export default React.memo(MyIdmAccordion);
